import React, {Fragment} from 'react';
import {translate} from 'react-i18next';
import 'webrtc-adapter';
import TagChooser from './TagChooser';

class OnionCamera extends React.PureComponent {

    constructor(props) {

        super(props);

        this.state = {

            description: '',
            hasCamera: undefined,
            opacity: .5,
            photo: null,
            position: null,
            saving: false,
            tags: [],
        };

        this.videoRef = React.createRef();

        this.handleAcceptClick = this.handleAcceptClick.bind(this);
        this.handleCloseClick = this.handleCloseClick.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleNewPhotoClick = this.handleNewPhotoClick.bind(this);
        this.handleTagRemove = this.handleTagRemove.bind(this);
        this.handleTagsAdd = this.handleTagsAdd.bind(this);
        this.handleTakePhotoClick = this.handleTakePhotoClick.bind(this);
    }

    addTags(...tags) {

        this.setState((prevState, props) => {

            const current = [...prevState.tags];

            tags.forEach(tag => {

                if (!current.includes(tag))
                    current.push(tag);
            });

            if (current.length !== prevState.tags.length)
                return {tags: current};
        });
    }

    changeOpacity(delta) {

        this.setState((prevState, props) => ({

            opacity: Math.min(Math.max(prevState.opacity + delta, 0), 1),
        }));
    }

    closeStream() {

        if (this.stream) {

            this.stream.getTracks().forEach(track => track.stop());
            this.stream = null;
        }
    }

    componentDidMount() {

        OnionCamera.hasCamera().then(hasCamera => this.setState({hasCamera}));

        if (navigator.geolocation)
            navigator.geolocation.getCurrentPosition(position => this.setState({position}));
    }

    componentDidUpdate() {

        if (this.state.hasCamera) {

            if (!this.state.photo && !this.stream) {

                OnionCamera.tryGetStream().then(stream => this.videoRef.current.srcObject = this.stream = stream);
            }
            else if (this.state.photo) {

                this.closeStream();
            }
        }
    }

    componentWillUnmount() {

        this.closeStream();
    }

    async handleAcceptClick() {

        if (this.props.onSave) {
            this.closeStream();
            this.setState({saving: true});

            try {

                const {description, photo: data, position, tags} = this.state;

                await this.props.onSave({

                    data,
                    description,
                    position,
                    tags,
                });
            }
            catch (ex) {

                console.log(ex);
                this.setState({saving: false});
            }

        }
    }

    handleCloseClick() {

        if (this.props.onClose)
            this.props.onClose();
    }

    handleNewPhotoClick() {

        this.setState({photo: null});
    }

    handleInputChange(e) {

        const target = e.target;
        const name = target.name;
        const value = target.type === 'checkbox' ? target.checked : target.value;

        this.setState({[name]: value});
    }

    handleTagRemove(tag) {

        this.removeTag(tag);
    }

    handleTagsAdd(tags) {

        this.addTags(...tags);
    }

    handleTakePhotoClick() {

        const canvas = document.createElement('canvas');

        canvas.width = this.videoRef.current.videoWidth;
        canvas.height = this.videoRef.current.videoHeight;

        const context = canvas.getContext('2d');

        context.drawImage(this.videoRef.current, 0, 0, this.videoRef.current.videoWidth, this.videoRef.current.videoHeight);

        this.setState({

            opacity: .25,
            photo: canvas.toDataURL('image/jpeg'),
        });
    }

    removeTag(tag) {

        this.setState((prevState, props) => {

            const tags = prevState.tags;

            if (tags.includes(tag))
                return {tags: tags.filter(x => x !== tag)};
        });
    }

    render() {

        const {t} = this.props;

        return (

            <div className="onion-camera d-flex flex-column bg-dark text-light" style={this.props.style}>
                <nav className="navbar">

                    <div className="btn-group ml-auto">
                        <button type="button" className="btn btn-light" disabled={this.state.saving} onClick={this.handleCloseClick}><i className="fas fa-times"/></button>
                    </div>

                </nav>
                <div className="container" style={{flex: 1, overflow: 'hidden' /* Not sure why, but this seems to be necessary. */}}>
                    <div className="row h-100">

                        {!this.state.hasCamera && (

                            <div className="col d-flex align-items-center justify-content-center">
                                {t('onionCamera.notAvailable')}
                            </div>
                        )}
                        {this.state.hasCamera && (

                            <div className="col d-flex align-items-center">
                                {!this.state.photo && <video ref={this.videoRef} className="w-100 mh-100" autoPlay/>}
                                {this.state.photo && <img src={this.state.photo} alt="" className="w-100 mh-100" style={{opacity: 1 - this.state.opacity}}/>}
                                {this.props.overlay && <img src={this.props.overlay} alt="overlay" className="overlay mh-100" style={{opacity: this.state.opacity}}/>}
                            </div>
                        )}

                    </div>
                </div>
                {this.state.hasCamera && (

                    <nav className="navbar flex-column">

                        <div className="form-group align-self-stretch align-self-md-center mb-2">
                            <input type="text" name="description" className="form-control" placeholder={t('onionCamera.descriptionPlaceholder')} value={this.state.description} onChange={this.handleInputChange}/>
                        </div>
                        <div className="form-group align-self-stretch align-self-md-center mb-2">
                            <TagChooser tags={this.state.tags} onTagsAdd={this.handleTagsAdd} onTagRemove={this.handleTagRemove}/>
                        </div>
                        <div className="btn-group">
                            {!this.state.photo && (

                                <Fragment>
                                    {this.props.overlay && <button type="button" className="btn btn-light" onClick={() => this.changeOpacity(-.1)}><i className="fas fa-minus"/></button>}
                                    {this.props.overlay && <button type="button" className="btn btn-light" onClick={() => this.changeOpacity(.1)}><i className="fas fa-plus"/></button>}
                                    <button type="button" className="btn btn-light" onClick={this.handleTakePhotoClick}><i className="fas fa-camera"/></button>
                                </Fragment>
                            )}
                            {this.state.photo && (

                                <Fragment>
                                    <button type="button" className="btn btn-light" disabled={this.state.saving} onClick={this.handleNewPhotoClick}><i className="fas fa-redo" /></button>
                                    {this.props.overlay && <button type="button" className="btn btn-light" onClick={() => this.changeOpacity(-.1)}><i className="fas fa-minus"/></button>}
                                    {this.props.overlay && <button type="button" className="btn btn-light" onClick={() => this.changeOpacity(.1)}><i className="fas fa-plus"/></button>}
                                    {!this.state.saving && <button type="button" className="btn btn-light" onClick={this.handleAcceptClick}>{t('onionCamera.upload')}</button>}
                                    {this.state.saving && <button type="button" className="btn btn-light" disabled><i className="fas fa-spinner fa-spin"/></button>}
                                </Fragment>
                            )}
                        </div>

                    </nav>
                )}
            </div>
        );
    }

    static async hasCamera() {

        if (!navigator.mediaDevices) return false;

        const devices = await navigator.mediaDevices.enumerateDevices();
        const videoInputs = devices.filter(device => device.kind === 'videoinput');

        return videoInputs.length > 0;
    }

    static async tryGetStream() {

        const resolutions = [

            2304, // 2304x1728, 3.9 MP
            2048, // 2048x1536, QXGA, 3.1 MP
            1920, // 1920x1440, 2.7 MP
            1600, // 1600x1200, UXGA, 1.9 MP
            1440, // 1440x1080, HD, 1.5 MP
            1280, // 1280x960, SXGA, 1.2 MP
            1024, // 1024x768, XGA,  0.78 MP
            800, // 800x600, SVGA, 0.48 MP
            640, // 640x480, VGA, 0.3 MP

            // Inverse aspect ratios:

            1728,
            1536,
            1440,
            1200,
            1080,
            960,
            768,
            600,
            480,
        ];

        for (const width of resolutions) {

            try {

                return await navigator.mediaDevices.getUserMedia({audio: false, video: {facingMode: 'environment', width: {exact: width}, height: {exact: (width / 4) * 3}}});
            }
            catch (ex) {

                if (ex.name === 'NotAllowedError') {

                    return;
                }
                else if (ex.name !== 'OverconstrainedError')
                    throw ex;
            }
        }
    }
}

export default translate()(OnionCamera);



// WEBPACK FOOTER //
// ./src/components/OnionCamera.js